import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Chip, TextField } from '@mui/material';
import Downshift from 'downshift';

const TagsInput = ({ ...props }) => {
  const {
    setSelectedItem,
    handleInputChange,
    handleDelete,
    handleKeyDown,
    selectedItem,
    handleChange,
    inputValue,
    selectedTags,
    placeholder,
    tags,
    ...other
  } = props;

  useEffect(() => {
    setSelectedItem(tags);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags]);

  useEffect(() => {
    selectedTags(selectedItem);
  }, [selectedItem, selectedTags]);

  return (
    <>
      <Downshift
        id='downshift-multiple'
        inputValue={inputValue}
        onChange={handleChange}
        selectedItem={selectedItem}
      >
        {({ getInputProps }) => {
          const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
            onKeyDown: handleKeyDown,
            placeholder,
          });
          return (
            <div>
              <TextField
                style={{ margin: '10px 0' }}
                variant='outlined'
                InputProps={{
                  startAdornment: selectedItem.map((item) => (
                    <Chip
                      key={item}
                      tabIndex={-1}
                      label={item}
                      onDelete={handleDelete(item)}
                    />
                  )),
                  onBlur,
                  onChange: (event) => {
                    handleInputChange(event);
                    onChange(event);
                  },
                  onFocus,
                }}
                {...other}
                {...inputProps}
              />
            </div>
          );
        }}
      </Downshift>
    </>
  );
};
TagsInput.defaultProps = {
  tags: [],
};
TagsInput.propTypes = {
  selectedTags: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
};

export default TagsInput;
